// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".OddsPanelOutcome__odd-description___2CMgl span{color:#61717b}", ""]);
// Exports
exports.locals = {
	"odd-description": "OddsPanelOutcome__odd-description___2CMgl"
};
module.exports = exports;
